import createApolloClient from './createApolloClient'
import services from 'App/services'
import getEnv from 'App/Root/getEnv'
import getCustom from 'App/Root/getCustom'

const env = getEnv()
const clients = {}

for (const key in services) {
  const service = services[key]
  const {urls} = service
  const subdomain = key === 'main' ? 'api' : key
  const url = getCustom(subdomain) || urls[env]
  clients[key] = createApolloClient({
    endpointURL: url,
    useSubscriptions: service.useSubscriptions
  })
}

export default clients
